import memoize from "lodash/memoize";

// Popperjs needs a DOM-like element to work with, but we're using refs
export class ReferenceProxy {
  ref = null;
  constructor(refObject) {
    this.ref = refObject;
  }

  getBoundingClientRect() {
    return this.ref.current?.getBoundingClientRect?.() ?? {};
  }

  get clientWidth() {
    return this.getBoundingClientRect().width;
  }

  get clientHeight() {
    return this.getBoundingClientRect().height;
  }

  get parentNode() {
    return this.ref.current ? this.ref.current.parentNode : undefined;
  }
}

const isRefObject = (ref) => {
  // https://github.com/facebook/react/blob/v16.8.2/packages/react-reconciler/src/ReactFiberCommitWork.js#L665
   
  return ref !== null && typeof ref === "object" && ref.hasOwnProperty("current");
};

/**
 * Popper.js does not support ref objects from `createRef()` as referenceElement. If we will pass
 * directly `ref`, `ref.current` will be `null` at the render process. We use memoize to keep the
 * same reference between renders.
 *
 * @see https://popper.js.org/popper-documentation.html#referenceObject
 */
export const createReferenceProxy = memoize(
  (reference) => new ReferenceProxy(isRefObject(reference) ? reference : { current: reference })
);